import { ChildDetailedForParentDto, EditChildForParentFormFields, ChildMealType } from 'types';

export const parseChildForParentIntoEditChildForParentFormFields: (
    childData: ChildDetailedForParentDto,
) => EditChildForParentFormFields = (childData) => {
    const { address, diseases, allergies, agreements } = childData.child;

    let dietId: string | undefined;
    const selectedMeals: ChildMealType[] = [];

    if (childData.diet) {
        // Handle ChildDiet (has institutionDiet)
        if ('institutionDiet' in childData.diet && childData.diet.institutionDiet) {
            dietId = (childData.diet.institutionDiet as { id: string }).id;

            if ('breakfast' in childData.diet && childData.diet.breakfast) {
                selectedMeals.push('breakfast');
            }
            if ('soup' in childData.diet && childData.diet.soup) {
                selectedMeals.push('soup');
            }
            if ('dinner' in childData.diet && childData.diet.dinner) {
                selectedMeals.push('dinner');
            }
            if ('snack' in childData.diet && childData.diet.snack) {
                selectedMeals.push('snack');
            }
        }
        // Handle ChildDietDTO (has meals array)
        else if ('meals' in childData.diet && Array.isArray(childData.diet.meals)) {
            // For ChildDietDTO, we don't have individual meal flags, so we'll set all to true
            // or we could map the meals array to the corresponding types if there's a mapping
            selectedMeals.push('breakfast', 'soup', 'dinner', 'snack');
        }
    }

    return {
        street: address?.street || '',
        city: address?.city || '',
        zipCode: address?.zipCode || '',
        ...(dietId && { diet: dietId }),
        ...(selectedMeals.length > 0 && { selectMealsType: selectedMeals }),
        diseases: diseases || '',
        allergens: allergies || '',
        socialNetworksImageSharingAgreementInstagram: agreements
            ? String(agreements.instagram)
            : '',
        socialNetworksImageSharingAgreementFacebook: agreements ? String(agreements.facebook) : '',
        socialNetworksImageSharingAgreementTikTok: agreements ? String(agreements.tiktok) : '',
        socialNetworksImageSharingAgreementWebsite: agreements ? String(agreements.website) : '',
    };
};
